'use strict';

var requestBuilder_constants = require('./constants.js');

function buildRequestHeader({ version, defaultHeaders, requestFormat, }) {
    const csrfCookieValue = getCookieValue(requestBuilder_constants.CSRF_TOKEN_COOKIE_NAME);
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (requestFormat === 'JSON' ? { 'Content-Type': 'application/json' } : {})), { Accept: 'application/json' }), defaultHeaders), (version ? { [requestBuilder_constants.Header.WebAppVersion]: version } : {})), (csrfCookieValue ? { [requestBuilder_constants.Header.CSRF]: csrfCookieValue } : {})), getGlobalHeaders());
}
function getCookieValue(name) {
    for (const cookieSegment of document.cookie.split(/;\s*/)) {
        if (cookieSegment.includes(`${name}=`)) {
            return cookieSegment.replace(`${name}=`, '');
        }
    }
    return null;
}
function getGlobalHeaders() {
    if (!globalThis.GlobalHeaders ||
        typeof globalThis.GlobalHeaders !== 'object') {
        return {};
    }
    const globalHeaders = Object.assign({}, globalThis.GlobalHeaders);
    for (const property in globalHeaders) {
        if (globalHeaders[property] == null) {
            delete globalHeaders[property];
        }
    }
    return globalHeaders;
}

exports.buildRequestHeader = buildRequestHeader;
exports.getCookieValue = getCookieValue;
//# sourceMappingURL=buildRequestHeader.js.map
